import { render, staticRenderFns } from "./TuoleleCourseDetails.vue?vue&type=template&id=76f066ee&scoped=true&"
import script from "./TuoleleCourseDetails.vue?vue&type=script&lang=js&"
export * from "./TuoleleCourseDetails.vue?vue&type=script&lang=js&"
import style0 from "./TuoleleCourseDetails.vue?vue&type=style&index=0&id=76f066ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f066ee",
  null
  
)

export default component.exports